module.exports = __webpack_public_path__ + "img/login-bg-2.96e83b58.jpg";